import { Table } from "antd";
import styled from "styled-components";

export const ReportListingWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 1rem;
`;

export const StyledTable = styled(Table)`
  .ant-table-cell {
    padding: 5px;
  }
`;